import { Controller } from "stimulus"
// Import UJS so we can access the Rails.ajax method
import Rails from "@rails/ujs"
import { Turbo } from "@hotwired/turbo-rails"
window.Turbo = Turbo
export default class extends Controller {
  static targets = [ "link", "store", "sub", "totalventas", "entries", "pagination", "nextlink", "date", "loader", "bottomloader", "endresults" ]
  static values = {
    next: String
  }

  connect() {

  }

  show_sale() {
    event.preventDefault()
    console.log(this.url)

    if(this.url) {
      Turbo.visit(this.url, { action: "advance" })
    }
  }

  change_date() {
    console.log(`${this.store}/${this.date}`)

    let url = `${window.location.origin}/ventas/${this.store}/${this.date}`
    console.log(url)
    this.loaderTarget.classList.remove('hidden')

    Turbo.visit(url, { action: "advance" })
  }

  change_store() {
    console.log(`${this.store}/${this.date}`)

    let url = `${window.location.origin}/ventas/${this.store}/${this.date}`
    console.log(url)
    this.loaderTarget.classList.remove('hidden')

    Turbo.visit(url, { action: "advance" })
  }

  scrollnextpage(){
    // let next_page = this.paginationTarget.querySelector("a[rel='next']")
    if (!this.hasNextlinkTarget) { return } // Better using stimulus js targets :D
    let next_page = this.nextlinkTarget

    //if (next_page == null){ return }

    let url = next_page.href
    let body = document.body,
        html = document.documentElement

    const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)

    if (window.pageYOffset >= height - window.innerHeight - 100){
      // console.log(`${this.nextValue} vs ${next_page} = ${this.nextValue == next_page}`)
      if (this.nextValue == next_page) { return } // Don't scroll if its the same page

      this.nextValue = next_page
      console.log(`scrolling to next page ${url}`)
      this.loadMore(url)
    }
  }

  loadMore(url){
    this.bottomloaderTarget.classList.remove('hidden')
    this.endresultsTarget.classList.add('hidden')

    Rails.ajax({
          type: 'GET',
          url: url,
          dataType: 'json',
          success: (data) => {
            // console.log(data)
            this.entriesTarget.insertAdjacentHTML('beforeend', data.entries)
            this.paginationTarget.innerHTML = data.custom_pagination
            this.bottomloaderTarget.classList.add('hidden')
            this.endresultsTarget.classList.remove('hidden')
          }
        }
    )
  }

  get url() {
    return this.linkTarget.href
  }

  get store() {
    return this.storeTarget.value
  }

  get sub() {
    return this.subTarget.value
  }

  get date() {
    return this.dateTarget.value
  }
}
